import React from 'react';
import { OauthApplicationsTable } from '../../../components/OauthApplications';

interface OauthApplicationsPanelProps {
  organization: { id: string; publicId: string };
}

export const OauthApplicationsPanel = ({
  organization,
}: OauthApplicationsPanelProps) => (
  <OauthApplicationsTable
    organizationId={organization.id}
    organizationPublicId={organization.publicId}
  />
);
